import {
    CLIENT_PLUGIN_REMOVED,
    CLIENT_PLUGIN_SETCONFIGURATIONS,
    CLIENT_PLUGIN_RESET_CONFIGURATIONS,
    CLIENT_PLUGIN_SETNOTES,
    CLIENT_PLUGIN_RESET_NOTES,
    CLIENT_PLUGIN_RESET_CONFIGURATIONBYPLUGIN,
    CLIENT_PLUGIN_RESET_NOTEBYPLUGIN,
} from '../ActionTypes';

//TODO: Remove
const initialState = {
    plugins: [],
    pluginConfigurations: [],
    pluginNotes: [],
};

const clientPluginsReduction = (state = initialState, action) => {
    switch (action.type) {
        case CLIENT_PLUGIN_REMOVED:
            return {
                ...state,
                plugins: state.plugins.filter(
                    (el) => el.id !== action.payload.pluginId
                ),
            };
        case CLIENT_PLUGIN_SETCONFIGURATIONS:
            return {
                ...state,
                pluginConfigurations: [
                    ...state.pluginConfigurations,
                    action.payload,
                ],
            };
        case CLIENT_PLUGIN_RESET_CONFIGURATIONS:
            return {
                ...state,
                pluginConfigurations: action.payload,
            };
        case CLIENT_PLUGIN_SETNOTES:
            let notesData = action.payload;
            let pluginNotesData = state.pluginNotes;
            let actionData;

            if (pluginNotesData.length <= 0) {
                actionData = [...state.pluginNotes, action.payload];
            } else {
                let objIndex = pluginNotesData.findIndex(
                    (obj) => obj.pluginId === notesData.pluginId
                );

                if (objIndex !== -1) {
                    pluginNotesData[objIndex].note = notesData.note;
                    actionData = pluginNotesData;
                } else {
                    actionData = [...state.pluginNotes, action.payload];
                }
            }

            return {
                ...state,
                pluginNotes: actionData,
            };
        case CLIENT_PLUGIN_RESET_NOTES:
            return {
                ...state,
                pluginNotes: action.payload,
            };
        case CLIENT_PLUGIN_RESET_CONFIGURATIONBYPLUGIN:
            return {
                ...state,
                pluginConfigurations: state.pluginConfigurations.filter(
                    (item) => item.pluginId !== action.payload
                ),
            };
        case CLIENT_PLUGIN_RESET_NOTEBYPLUGIN:
            return {
                ...state,
                pluginNotes: state.pluginNotes.filter(
                    (item) => item.pluginId !== action.payload
                ),
            };
        default:
            return state;
    }
};

export default clientPluginsReduction;
